/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Tip, log } from '@insticator/insticator-ui'; // iui-utils
import ImageIndicator from 'material/embeds/imageindicator/imageindicator';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/shared/background/background_styles';
import { Icon } from '@insticator/insticator-ui/dist/material';



/* ========== ~~~~~~~~~~ EMBED : BACKGROUND ~~~~~~~~~~ ========== */
class Background extends Component {
	constructor(props) {
		super(props);
    this.state = {
      isImageProcessed: true // to check if the returned BE image is already fully processed
    }
    }
    handleSelect = () => {
        this.props.setActiveSelection(this.props.isSelected ? 'none' : 'background')
    };

    componentDidMount() {
      this.setState({isImageProcessed: true})
    }

    componentWillUnmount() {
      this.setState({isImageProcessed: false})
    }

    handleImageLoaded = () => {
      log('INFO: Image processed', this.props.backgroundImageURL)
      this.setState({isImageProcessed: true})
    }

    handleS3Error = () => {
      log('ERROR: Image is still processing', this.props.backgroundImageURL)
      this.setState({isImageProcessed: false})
    }

	render() {
		const bgImgURL = `url(${this.props.currentBackgroundImage || this.props.backgroundImageURL})`;
		const bgImgSrc = this.props.previewBackgroundImageURL === null ? bgImgURL : `url(${this.props.previewBackgroundImageURL})`;
    const bgImg = this.props.previewBackgroundImageURL === null ? this.props.backgroundImageURL : this.props.previewBackgroundImageURL
		const bgColor = this.props.backgroundColor === null || this.props.backgroundColor === undefined ? 'rgba(48,48,48,0.8)' : this.props.backgroundColor;
	    return(
	    	<div className={`${this.props.classes.background} selected-${this.props.isEditable && this.props.isSelected}`} onClick={this.handleSelect}>
          { this.props.isEditable && !this.state.isImageProcessed &&
            <div className={'imageprocessingnote'}>
              <Icon name={'spinner'} animation={'spin'}/>
              <h5>Image processing</h5>
              <Tip space={'left'} icon={'question-circle'} content={'The image you selected is being processed to reduce its size and ensure the fastest possible load times without affecting its visual integrity. The image will eventually show correctly in this preview.'} />
            </div> 
          }
	    		<div className={`overlay`} />
		    	<div className={`fade`} style={{ background: bgColor }} />        
		    	<div className={`image`} style={{ backgroundImage: bgImgSrc }} />
          {/* Hidden Image to check if the image provided by BE is processed or not */}
          { bgImg && <img className='image imagepreview' src={bgImg} alt={'background'} onError={this.handleS3Error} onLoad={this.handleImageLoaded} />}
		    	<ImageIndicator color={`white`} />
		    </div>
	    );
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Background);
